var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',[_c('v-label',[_vm._v(_vm._s(_vm.label ? _vm.label : 'Cor'))]),_c('v-color-picker',{attrs:{"label":_vm.label ? _vm.label : 'Cor',"type":"color","mode":"hexa","show-swatches":"","swatches":[
      ['#DCE6E0', '#173042', '#ADADB6', '#253D4E'],
      ['#33CC99', '#E0EFEA', '#67D9D1', '#5D6F7B'],
      ['#0000BA', '#76ADF1', '#5C7FFF', '#3A35C7'],
      ['#595769', '#302D44', '#8EA7FF', '#6B66A3'],
      ['#9999FF', '#007B9A', '#B00020', '#2196F3'],
      ['#A6C4E8', '#046732', '#FB8C00', '#61676A'],
      ['#3D4251', '#E8E8E8', '#F4F4F4', '#E1FFD3'],
      ['#000000', '#FFFFFF', '#CCCCCC', '#DDDDDD']
    ]},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }